import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a5b8b60a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a5b8b60a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b8b60a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5b8b60a')) {
      api.createRecord('a5b8b60a', component.options)
    } else {
      api.reload('a5b8b60a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a5b8b60a&scoped=true", function () {
      api.rerender('a5b8b60a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commitRecord/index.vue"
export default component.exports